import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Bell } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { HamburgerMenu } from '../layout/HamburgerMenu';
import { LanguageSheet } from '../layout/LanguageSheet';

export function MobileHomeTop() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, profile, isAuthenticated, unreadNotifications } = useAuth();
  const [languageSheetOpen, setLanguageSheetOpen] = useState(false);

  const name = user?.first_name || profile?.firstName || (isAuthenticated ? t('common.user') : t('common.guest'));
  const initial = name.slice(0, 1).toUpperCase();

  return (
    <div className="cs-m-top cs-m-top--compact">
      <header className="cs-m-top__bar">
        <div className="cs-m-top__left">
          <HamburgerMenu onOpenLanguage={() => setLanguageSheetOpen(true)} />

          <button type="button" className="cs-m-top__brand" onClick={() => navigate('/')}>
            <img
              className="cs-m-top__logo"
              src="/brand/logo-64.webp"
              alt=""
              width={32}
              height={32}
              decoding="async"
            />
            <span className="cs-m-top__title">CozzySIM</span>
          </button>
        </div>

        <div className="cs-m-top__right">
          <button
            type="button"
            className="cs-m-top__icon-btn cs-m-top__bell"
            aria-label={t('notifications.title')}
            onClick={() => navigate(isAuthenticated ? '/notifications' : '/login?returnTo=%2Fnotifications')}
          >
            <Bell size={20} strokeWidth={2} />
            {unreadNotifications > 0 && <span className="cs-m-top__bell-dot" aria-hidden />}
          </button>

          <button
            type="button"
            className="cs-m-top__avatar"
            aria-label={t('nav.profile')}
            onClick={() => navigate(isAuthenticated ? '/profile' : '/login?returnTo=%2Fprofile')}
          >
            {profile?.avatarUrl ? <img src={profile.avatarUrl} alt="" /> : initial}
          </button>
        </div>
      </header>

      <LanguageSheet open={languageSheetOpen} onClose={() => setLanguageSheetOpen(false)} />
    </div>
  );
}
